export default [
    {
        path: '/',
        name: 'record-create',
        redirect: {name: 'record-create-section', params: {section: 'intro'}},
    },
    {
        path: '/records/create/:section',
        name: 'record-create-section',
        component: () => import(/* webpackChunkName: "csp-app/views/recordByCustomer/create" */'@csp-app/views/recordByCustomer/Create.vue'),
    },
    {
        path: '/records/create-success',
        name: 'record-create-success',
        component: () => import(/* webpackChunkName: "csp-app/views/recordByCustomer/create-success" */'@csp-app/views/recordByCustomer/CreateSuccess.vue'),
    },
];
